import React, { useState, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faMinusCircle,
  faPlusCircle,
  faWrench,
  faTrash,
  faFileMedical,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import {
  Suport,
  ButtonUpdateData,
  InputForm,
  InputFormHistoric,
  ButtonShowReports,
} from "./styles";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Table,
  ModalFooter,
  Row,
  Col,
  FormGroup,
  InputGroup,
  Spinner,
} from "reactstrap";
import {
  faHistory,
  faHospitalUser,
  faSort,
} from "@fortawesome/free-solid-svg-icons";
import { SessionManager } from "../../utils/functions";
import api from "../../services/client/api";
import Laudos from "../../components/Laudos";
export default function ListReportsTumorBoard({
  reports,
  token,
  medicos,
  username,
}) {
  const [medicoSearch, setMedicoSearch] = useState("");
  const [historic, setHistoric] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [medicoSelecionado, setMedicoSelecionado] = useState(null);
  const [filteredMedicos, setFilteredMedicos] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  const toggleModal = () => setModalOpen(!modalOpen);
  const [loadingHistoric, setLoadingHistoric] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [reportToDelete, setReportToDelete] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [showLaudos, setShowLaudos] = useState(false);
  const session = SessionManager();
  const getToday = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };
  const [newHistoric, setNewHistoric] = useState({
    dataRegistro: getToday(),
    descricaoRegistro: "",
  });
  const [form, setForm] = useState({
    codRequisicao: "",
    nomePaciente: "",
    idade: "",
    nomeMedico: "",
    instituicao: "",
    dataReuniao: "",
    descricao: "",
  });

  const openModalWithData = async (report) => {
    setHistoric([]);
    setForm({
      codTumorBoard: report.CodTumorBoard || "",
      nomePaciente: report.NomPaciente || "",
      idade: report.Idade || "",
      nomeMedico: report.NomMedico || "",
      instituicao: report.NomComercial || "",
      dataReuniao: report.DtaReuniao ? report.DtaReuniao.split("T")[0] : "",
      descricao: "",
    });
    setMedicoSearch(report.NomMedico || "");

    await getHistoric(report);

    setModalOpen(true);
  };

  const openConfirmDelete = (report) => {
    setReportToDelete(report);
    setConfirmModal(true);
  };

  const handleRemove = async () => {
    if (!reportToDelete) return;

    try {
      const payload = {
        CodTumorBoard: reportToDelete.CodTumorBoard,
        Ativo: reportToDelete.Ativo,
        username: username,
      };

      const response = await api().user().HideReport(token, payload);

      if (response.status === 200) {
        setConfirmModal(false);
        setReportToDelete(null);
        alert("Alteração salva com sucesso!");
        window.location.reload();
      }
    } catch (error) {
      console.error("Erro ao remover:", error);
    }
  };

  const handleHistoricChange = (e) => {
    const { name, value } = e.target;
    setNewHistoric((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddHistoric = async () => {
    if (!newHistoric.descricaoRegistro || !newHistoric.dataRegistro) {
      alert("Preencha data e descrição");
      return;
    }

    const success = await insertHistoric({
      CodTumorBoard: form.codTumorBoard,
      DataReg: new Date(newHistoric.dataRegistro).toISOString(),
      DesEvolucao: newHistoric.descricaoRegistro,
    });

    if (!success) {
      alert("Erro ao salvar histórico");
      return;
    }

    const novoItem = {
      DesEvolucao: newHistoric.descricaoRegistro,
      DataReg: newHistoric.dataRegistro,
    };

    setHistoric((prev) => [...prev, novoItem]);

    setNewHistoric({
      dataRegistro: "",
      descricaoRegistro: "",
    });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
  };
  const handleSubmit = async () => {
    const success = await updateTumorBoard();

    if (!success) {
      alert("Erro ao salvar");
      return;
    }

    alert("Salvo com sucesso!");

    toggleModal();

    // limpar form
    setForm({
      codRequisicao: "",
      nomePaciente: "",
      idade: "",
      nomeMedico: "",
      instituicao: "",
      dataReuniao: getToday(),
      descricao: "",
    });
  };
  const getHistoric = useCallback(
    async (report) => {
      const data = {
        CodTumorBoard: report.CodTumorBoard,
        username: username,
      };
      setLoadingHistoric(true);
      try {
        const response = await api().user().getHistoricTumorBoard(token, data);

        if (response.status === 401) {
          return session.logoff();
        }
        if (response.status === 404) {
          setLoadingHistoric(false);
        }

        if (response.status === 200) {
          setLoadingHistoric(false);
          setHistoric(response.output);
        }
      } catch (error) {
        setLoadingHistoric(false);
        console.error("Erro ao buscar histórico:", error);
      }
    },
    [session, token, username],
  );
  if (!reports || reports.length === 0) return null;

  const mainReport = reports[0];

  const sortedHistoric = historic;
  const insertHistoric = async ({ CodTumorBoard, DataReg, DesEvolucao }) => {
    try {
      const payload = {
        CodTumorBoard,
        DataReg,
        DesEvolucao,
        username: username,
      };

      const response = await api().user().insertHistoric(token, payload);

      if (response.status === 201) {
        return true;
      }

      return false;
    } catch (error) {
      console.error("Erro ao salvar:", error);
      return false;
    }
  };
  const handleMedicoChange = (e) => {
    const value = e.target.value;
    setMedicoSearch(value);

    if (!value) {
      setFilteredMedicos([]);
      return;
    }

    const filtered = medicos.filter((m) =>
      m.NomMedico.toLowerCase().includes(value.toLowerCase()),
    );

    setFilteredMedicos(filtered);
    setShowDropdown(true);
  };

  const handleSelectMedico = (medico) => {
    setMedicoSelecionado(medico);
    setMedicoSearch(medico.NomMedico);
    setShowDropdown(false);

    // se quiser salvar no form também:
    setForm((prev) => ({
      ...prev,
      nomeMedico: medico.NomMedico,
      codMedico: medico.CodMedico,
      codInstituicao: medico.CodInstituicao,
    }));
  };

  const updateTumorBoard = async (report) => {
    try {
      if (!form.dataReuniao || !form.codMedico) {
        alert("Preencha os campos obrigatórios");
        return false;
      }

      const payload = {
        CodTumorBoard: form.codTumorBoard,
        CodMedico: form.codMedico || null,
        CodInstituicao: medicoSelecionado?.CodInstituicao || null,
        DtaReuniao: new Date(form.dataReuniao).toISOString(),
        username: username,
      };

      const response = await api().user().updateTumorBoard(token, payload);

      if (response.status === 201) {
        window.location.reload();
        return true;
      }

      return false;
    } catch (error) {
      console.error("Erro ao salvar:", error);
      return false;
    }
  };

  const openLaudos = (report) => {
    setShowLaudos(true);
  };

  const handleCloseLaudos = () => {
    setShowLaudos(false);
  };

  return (
    <>
      {/* Linha principal */}
      <Modal isOpen={modalOpen} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>
          Registrar Reunião realizada
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={8}>
              <FormGroup>
                <span className="label-form">Nome do paciente:</span>
                <InputForm
                  type="text"
                  name="nomePaciente"
                  value={form.nomePaciente}
                  onChange={handleChange}
                  disabled
                  required
                />
              </FormGroup>
            </Col>

            <Col md={3}>
              <FormGroup>
                <span className="label-form">Idade:</span>
                <InputForm
                  type="number"
                  name="idade"
                  disabled
                  value={form.idade}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <span className="label-form">Data da reunião:</span>
                <InputForm
                  type="date"
                  name="dataReuniao"
                  value={form.dataReuniao}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={8}>
              <FormGroup style={{ position: "relative" }}>
                <span className="label-form">Nome do médico:</span>

                <InputForm
                  type="text"
                  name="nomeMedico"
                  value={medicoSearch}
                  onChange={handleMedicoChange}
                  onFocus={() => setShowDropdown(true)}
                  autoComplete="off"
                />

                {showDropdown && filteredMedicos.length > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      width: "100%",
                      background: "#fff",
                      border: "1px solid #ccc",
                      maxHeight: "200px",
                      overflowY: "auto",
                      zIndex: 10,
                    }}
                  >
                    {filteredMedicos.map((medico, index) => (
                      <div
                        key={index}
                        style={{
                          padding: "8px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleSelectMedico(medico)}
                      >
                        {medico.NomMedico}
                      </div>
                    ))}
                  </div>
                )}
              </FormGroup>
            </Col>
          </Row>

          <div
            style={{
              marginTop: "10px",
              marginBottom: "10px",
              marginLeft: "10px",
              fontWeight: "bold",
            }}
          >
            Histórico <FontAwesomeIcon icon={faHistory} />
          </div>

          <div
            style={{
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            {loadingHistoric ? (
              <p>
                Carregando histórico <Spinner />
              </p>
            ) : historic.length === 0 ? (
              <Table bordered responsive>
                <thead>
                  <tr>
                    <th style={{ textAlign: "center" }}>Data</th>
                    <th>Descrição</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Histórico existente */}
                  {sortedHistoric.map((item, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: "center" }}>
                        {item.DataReg
                          ? item.DataReg.split("T")[0]
                              .split("-")
                              .reverse()
                              .join("/")
                          : "-"}
                      </td>
                      <td>{item.DesEvolucao}</td>
                    </tr>
                  ))}

                  <tr style={{ backgroundColor: "#e8f4ff" }}>
                    <td style={{ width: "150px" }}>
                      <Input
                        type="date"
                        name="dataRegistro"
                        value={newHistoric.dataRegistro}
                        onChange={handleHistoricChange}
                      />
                    </td>

                    <td>
                      <div style={{ display: "flex", gap: "10px" }}>
                        <Input
                          type="text"
                          name="descricaoRegistro"
                          placeholder="Digite a evolução..."
                          value={newHistoric.descricaoRegistro}
                          onChange={handleHistoricChange}
                        />

                        <Button color="primary" onClick={handleAddHistoric}>
                          <FontAwesomeIcon
                            style={{ fontSize: "18px" }}
                            icon={faPlusCircle}
                          />
                        </Button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            ) : (
              <Table bordered responsive>
                <thead>
                  <tr>
                    <th style={{ textAlign: "center" }}>Data</th>
                    <th>Descrição</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Histórico existente */}
                  {sortedHistoric.map((item, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: "center" }}>
                        {item.DataReg
                          ? item.DataReg.split("T")[0]
                              .split("-")
                              .reverse()
                              .join("/")
                          : "-"}
                      </td>
                      <td>{item.DesEvolucao}</td>
                    </tr>
                  ))}

                  <tr style={{ backgroundColor: "#e8f4ff" }}>
                    <td style={{ width: "150px" }}>
                      <Input
                        type="date"
                        name="dataRegistro"
                        value={newHistoric.dataRegistro}
                        onChange={handleHistoricChange}
                      />
                    </td>

                    <td>
                      <div style={{ display: "flex", gap: "10px" }}>
                        <Input
                          type="text"
                          name="descricaoRegistro"
                          placeholder="Digite a evolução..."
                          value={newHistoric.descricaoRegistro}
                          onChange={handleHistoricChange}
                        />

                        <Button color="primary" onClick={handleAddHistoric}>
                          <FontAwesomeIcon
                            style={{ fontSize: "18px" }}
                            icon={faPlusCircle}
                          />
                        </Button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            )}
          </div>
        </ModalBody>

        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            Editar
          </Button>
        </ModalFooter>
      </Modal>

      <tr>
        <td style={{ textAlign: "center" }}></td>

        <td style={{ textAlign: "center" }}>
          <ButtonUpdateData
            color="secondary"
            onClick={() => openModalWithData(mainReport)}
          >
            Ver Detalhes
            <FontAwesomeIcon icon={faPlusCircle} />
          </ButtonUpdateData>
        </td>

        <td style={{ textAlign: "center" }}>{mainReport.NomPaciente}</td>
        <td style={{ textAlign: "center" }}>
          {new Date(mainReport.DtaReuniao).toLocaleDateString("pt-BR", {
            timeZone: "UTC",
          })}
        </td>
        <td style={{ textAlign: "center" }}>{mainReport.NomMedico}</td>

        <td style={{ textAlign: "center" }}>{mainReport.NomComercial}</td>
        <td style={{ textAlign: "center" }}>
          {mainReport.CodPaciente ? (
            <ButtonShowReports
              color="primary"
              onClick={() => openLaudos(mainReport)}
            >
              Exames
              <FontAwesomeIcon
                style={{ marginLeft: "1px" }}
                icon={faFileMedical}
                title={"Abrir Laudos"}
              />
            </ButtonShowReports>
          ) : (
            <Button color="secondary" disabled>
              Nenhum exame encontrado
            </Button>
          )}
        </td>
        <td style={{ textAlign: "center" }}>
          <Button color="light" onClick={() => openConfirmDelete(mainReport)}>
            <FontAwesomeIcon icon={faEyeSlash} title={"Remover Desfecho"} />
          </Button>
        </td>

        {showLaudos && (
          <Laudos
            token={token}
            username={username}
            onClose={handleCloseLaudos}
            patient={mainReport}
          />
        )}

        <Modal
          isOpen={confirmModal}
          toggle={() => setConfirmModal(!confirmModal)}
        >
          <ModalHeader toggle={() => setConfirmModal(!confirmModal)}>
            Ocultar da listagem
          </ModalHeader>

          <ModalBody style={{ textAlign: "center" }}>
            <b>Tem certeza que deseja ocultar o paciente da listagem?</b>
          </ModalBody>

          <ModalFooter>
            <Button color="secondary" onClick={() => setConfirmModal(false)}>
              Cancelar
            </Button>

            <Button color="danger" onClick={handleRemove}>
              Ocultar
            </Button>
          </ModalFooter>
        </Modal>
      </tr>
    </>
  );
}
